import { render } from "./TopAppMobile.vue?vue&type=template&id=875ad3fc&scoped=true"
import script from "./TopAppMobile.vue?vue&type=script&lang=js"
export * from "./TopAppMobile.vue?vue&type=script&lang=js"

import "./TopAppMobile.vue?vue&type=style&index=0&id=875ad3fc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875ad3fc"]])

export default __exports__